/**
 * Study plans (Plan de Estudios → Planes): the school's programmes that group the yearly
 * formations (Dirección Cinematográfica = Dirección 1º/2º/3º). Loaded from the server and
 * edited in the app; ids are stable, so a rename never breaks formations or CRM contacts.
 */
const StudyPlanService = {
    plans: [],
    // Formation types (Plan de Estudios → Tipos) a plan can belong to, in their order.
    get CATEGORIES() {
        if (typeof FormationTypeService === 'undefined') return [];
        return FormationTypeService.getTypes().map(type => ({id: type.id, label: type.pluralName, single: type.name, active: type.active}));
    },

    async load() {
        const response = await fetch('/api/study-plans', {headers: {'X-SICAF-CSRF': AuthManager.getCsrfToken()}, cache: 'no-store'});
        const result = await response.json().catch(() => null);
        if (!response.ok || !Array.isArray(result?.plans)) throw new Error(result?.error || 'No se pudieron cargar los planes de estudios.');
        this.plans = result.plans;
        return this.plans;
    },

    getPlans({includeInactive = true} = {}) {
        return this.plans.filter(plan => includeInactive || plan.active);
    },
    getPlan(id) { return this.plans.find(plan => plan.id === id) || null; },
    // Active plans of one formation type, in their order.
    byCategory(category) {
        return this.plans.filter(plan => plan.category === category && plan.active)
            .sort((a, b) => a.order - b.order || String(a.name).localeCompare(String(b.name), 'es'));
    },
    // Courses of a formation in this plan: the plan's own, else those of the type.
    years(planId, typeId) {
        const own = this.getPlan(planId)?.years;
        if (Array.isArray(own) && own.length) return own;
        return typeof FormationTypeService !== 'undefined' ? FormationTypeService.years(typeId || this.getPlan(planId)?.category) : [];
    },
    // Plan name for display; a deactivated plan says so.
    label(id) {
        const plan = this.getPlan(id);
        return plan ? plan.name + (plan.active ? '' : ' (desactivado)') : null;
    },

    async request(method, id, data) {
        const response = await fetch('/api/study-plans' + (id ? '/' + encodeURIComponent(id) : ''), {
            method, headers: {'Content-Type': 'application/json', 'X-SICAF-CSRF': AuthManager.getCsrfToken()},
            ...(data ? {body: JSON.stringify(data)} : {})
        });
        const result = await response.json().catch(() => null);
        if (!response.ok || !result?.success) throw new Error(result?.error || 'No se pudo guardar el plan.');
        await this.load();
        return result.plan || result;
    },
    create(data) { return this.request('POST', null, data); },
    update(id, data) { return this.request('PUT', id, data); },
    remove(id) { return this.request('DELETE', id); }
};

window.StudyPlanService = StudyPlanService;
